import React, { Component } from 'react'
import { connect } from 'react-redux'

import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'

import Section from 'components/Section'

import { doc, dirtyRead } from 'selectors/common'
import { totalIncome } from 'selectors/application'

import dataActions from 'actions/dataActions'

let select = dirtyRead(
	(state, props) => ({
		application: doc(state, props.applicationID)
	  , totalIncome: totalIncome(state, props.applicationID)
	})
)

export class AdditionalInfo extends Component{
	render(){
		let { props } = this
		let additionalInfo = props.application.primaryResident.additionalInfo
		return(
			<Section
				id="additionalInfo"
				title="Additional info"
			>
				<div className="additional-info">
					<p><span style={{fontWeight: "bold"}}>Filed for bankruptcy:</span> {additionalInfo.bankrut? "Yes" : "No"}</p>
					<p><span style={{fontWeight: "bold"}}>Been evicted:</span> {additionalInfo.eviction? "Yes" : "No"}</p>
					<p><span style={{fontWeight: "bold"}}>Been party to a lawsuit:</span> {additionalInfo.lawsuit? "Yes" : "No"}</p>
					<p><span style={{fontWeight: "bold"}}>Been convicted of a crime:</span> {additionalInfo.crime? "Yes" : "No"}</p>
					<div className="explain" style={{display:!additionalInfo.explain? "none" : "block"}} >
						<p><span style={{fontWeight: "bold"}}>Explain:</span> {additionalInfo.explain}</p>
					</div>
					<p><span style={{fontWeight: "bold"}}>Smoke:</span> {additionalInfo.smoke? "Yes" : "No"}</p>
					<p><span style={{fontWeight: "bold"}}>Pets:</span> {additionalInfo.pets? "Yes" : "No"}</p>
					<div className="pets-info" style={{display:!additionalInfo.petsInfo? "none" : "block"}} >
						<p><span style={{fontWeight: "bold"}}>Pets info:</span> {additionalInfo.petsInfo}</p>
					</div>
					<p><span style={{fontWeight: "bold"}}>Total income:</span> $ {props.totalIncome}</p>
					<SelectField
						floatingLabelText="Status"
						value={props.application.status? props.application.status : 'new'}
						onChange={(evt, indx, val) => props.STAGE({_id: props.applicationID, status: val})}
					>
						<MenuItem value={"new"} primaryText="New" />
						<MenuItem value={"accepted"} primaryText="Accepted" />
						<MenuItem value={"rejected"} primaryText="Rejected" />
					</SelectField>
				</div>
			</Section>
		)
	}
}

export default connect(select, dataActions)(AdditionalInfo)



// WEBPACK FOOTER //
// ./src/routes/manager/applicationForm/AdditionalInfo.js